'use strict';
import Promise from 'bluebird';
import $ from 'jquery';
import getToken from './token';
import { apiCall as cartApiCall } from './cart';

const API_URL = '/fi/api/v1/checkout/';
const pickupLocationsCache = {};

/**
 * @param {String} zipCode
 * @param {String} type
 * @return {Promise}
 */
export const getPickupLocations = (type, zipCode, city, address, countryCode = 'FI') => {
	if (!zipCode) return Promise.reject(new Error('Zip code is required'));

	const params = {
		type,
		zip: zipCode,
		city,
		address,
		countryCode,
	};
	const key = zipCode + city + address + type;
	const cached = pickupLocationsCache[key];
	if (cached) return Promise.resolve(cached);

	const xhr = $.getJSON(API_URL + 'pickuplocations/', params);

	return Promise.resolve(xhr).then(res => {
		if (res.locations) {
			pickupLocationsCache[key] = res.locations;
			return res.locations
		}
		return [];
	});
}

export const createOrder = (data) => {
	if (Array.isArray(data.email)) {
		data.email = data.email[0];
	}
	return getToken().then(token => {
		data.token = token;
		return Promise.resolve($.ajax({
			url: API_URL + 'orders/',
			method: 'POST',
			data: data
		}));
	});
}

export const getOrder = (orderId, options) => {
	return Promise.resolve($.get(`${API_URL}orders/${orderId}/`));
}

export const updateOrder = (orderId, data, definition) => {
	const params = {data}
	if (definition) params.definition = definition
	return getToken().then(token => {
		params.token = token
		return Promise.resolve($.post(`${API_URL}orders/${orderId}/`, params))
	})
}

export const updateOrderItems = (orderId) => {
	const params = {};
	return getToken().then(token => {
		params.token = token;
		return Promise.resolve($.post(`${API_URL}orderitems/${orderId}/`, params));
	});
}

export const getAvailableSaleCodes = (usedSaleCode, orderId) => {
	return Promise.resolve($.get(API_URL + 'salecodes/', { usedSaleCode, orderId })).then(res => res.salecodes);
}

export const getPaymentMethods = (params = {}) => {
	return Promise.resolve($.get(API_URL + 'paymentmethods/', params));//.then(res => res.paymentMethods);
}

export const getDeliveryMethods = (params = {}) => {
	return Promise.resolve($.get(API_URL + 'deliverymethods/', params)).then(res => res.deliveryMethods)
}

export const getSavedCards = () => {
	return Promise.resolve($.get(API_URL + 'savedcards/')).then(res => {
		return {
			paymentMethods: res.cards,
			cards: true
		}
	});
}

/**
 * @param {String} code
 * @return {Promise}
 */
export const applySaleCode = (code, orderId, isCustom = 0, voucherId = '') => {
	return cartApiCall('POST', API_URL + 'salecodes/', { code, orderId, voucherId, isCustom: isCustom ? 1 : 0 });
}

export const resetPassword = (email, params = {}) => {
	const {source} = params;
	return getToken().then(token => {
		return Promise.resolve($.post(API_URL + 'resetpassword/', {token, email, source}))
	})
}

export const getDeliveryCountries = (deliverymethod) => {
	return Promise.resolve($.get(API_URL + 'deliverycountries/', { deliverymethod }));
}

export const deleteSavedCard = (uuid) => {
	const url = `${API_URL}savedcards/?uuid=${uuid}`;
	return Promise.resolve($.ajax({ method: 'DELETE', url, dataType: 'text' }));
}
